import { render, staticRenderFns } from "./GroupOptions.vue?vue&type=template&id=2b27703e&scoped=true&"
import script from "./GroupOptions.vue?vue&type=script&lang=js&"
export * from "./GroupOptions.vue?vue&type=script&lang=js&"
import style0 from "./GroupOptions.vue?vue&type=style&index=0&id=2b27703e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b27703e",
  null
  
)

export default component.exports